
import { Component, Vue } from "vue-property-decorator";
import { apiMpCopyright, apiMpCopyrightEdit } from "@/api/setting";
import LsEditor from "@/components/editor.vue";

@Component({
    components: {
        LsEditor,
    },
})
export default class MpCopyright extends Vue {
    form: any = {
        status: 1,
        content: "",
        title: "",
        detail: "",
    };

    async onSubmit(): Promise<void> {
        await apiMpCopyrightEdit({ ...this.form });
        this.getConfig();
    }

    async getConfig(): Promise<void> {
        const res: any = await apiMpCopyright();
        for (const key in res) {
            this.$set(this.form, key, res[key]);
        }
        this.form.status = Number(this.form.status) === 0 ? 0 : 1;
    }

    created() {
        this.getConfig();
    }
}
